module.exports = __webpack_public_path__ + "static/media/ic_search_bar.212379c5.svg";